import QuerystringHelpers from '../helpers/QuerystringHelpers.js';
import LetterIndexScroller from './LetterIndexScroller.js';
import Router from '../router.js';

//optional features:
//1. update url after ajax call
//2. add ajax call for pagination
//3. remember open/closed state of filters for reload via paging

class Filter {
    constructor(elm) {
        this.elm = elm;
        this.$elm = $(elm);
        this.$currentForm = this.$elm.closest('form');

        this.queryStringHelpers = new QuerystringHelpers();

        this.queryString = this.queryStringHelpers.loadQueryStringAsQueryObject('');
        this.setFilter();

        this.setEventListeners();
    }

    setFilter() {
        if ($.isEmptyObject(this.queryString)) return;
        $.each(this.queryString, function (key, val) {
            let $target = $('input[name=' + key + ']');
            if ($target.attr('type') === 'checkbox') {
                $target.prop('checked', val);
            } else {
                $target.val(val);
            }
        });
    }

    setEventListeners() {
        this.$elm.find('.filter-field:not(.searchField-input)').on('change', this.onChange.bind(this));
        this.$elm.find('.searchField-input').on('keyup', $.debounce(this.onKeyup.bind(this), 800));
    }

    submit($form) {
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: response => {
                $('.searchResults-replace').html($(response).find('.searchResults-replace').html());
                $('.searchResults-filtersSubmit').html($(response).find('.searchResults-filtersSubmit').html());
                if ($('.searchResults-filtersFilter__letter').length) $('.searchResults-filtersFilter__letter').html($(response).find('.searchResults-filtersFilter__letter').html());
                this.queryStringHelpers.pushQueryToHistory(this.queryString);
                if ($('.letterIndex')) {
                    var router = new Router([LetterIndexScroller], ["LetterIndexScroller"]);
                    router.registerTransient('LetterIndexScroller').dom('.letterIndex', 'LetterIndexScroller');
                }
            }
        });
    }

    onChange(event) {
        var $target = $(event.target);
        var value = '';
        if ($target.attr('type') === 'checkbox') {
            value = $target.is(':checked');
        } else {
            value = $target.val();
        }
        this.queryString = this.queryStringHelpers.updateQueryObject(this.queryString, $target.attr('name'), value);
        this.submit(this.$currentForm);
    }

    onKeyup(event) {
        var $target = $(event.target);
        this.queryString = this.queryStringHelpers.updateQueryObject(this.queryString, $target.attr('name'), $target.val());
        this.submit(this.$currentForm);
    }
}

export default Filter;